<template>
    <div>
        <el-form label-width="80px">
            <el-row>
                <el-col :span="8" >
                    <el-form-item label="接口地址:">
                        <el-input v-model="form.url" placeholder="接口地址" clearable @input="Serinput"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <!-- <el-button type="primary" plain style="float:right" @click="SearchSubmit"> 搜索 </el-button> -->
                </el-col>
            </el-row>
        </el-form>
        <div>
            <!-- <el-button type="primary" size="mini" @click="submit" :disabled="SelectData.length <= 0">确定</el-button> -->
            <el-button type="primary" size="mini" @click="submit" >确定</el-button>
            <!-- <el-button size="mini" @click="clone">清空并返回</el-button> -->
            <el-button size="mini" @click="Filterselecteddata" plain>{{titleStatus ? '筛选' : '取消'}}已选中数据</el-button>
        </div>
        <el-table
            @selection-change="handleSelectionChange"
            ref="form"
            :data="dataList.slice((matterParams.current - 1) * matterParams.size,matterParams.current * matterParams.size)"
            :row-key="(row) => { return row.id }">
             <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
             <el-table-column prop="url" label="接口地址" show-overflow-tooltip></el-table-column>
             <el-table-column prop="description" label="接口描述" show-overflow-tooltip></el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagination
            v-show="(Number(dataList.length) > 0)"
            :total="Number(dataList.length)"
            :page.sync="matterParams.current"
            :limit.sync="matterParams.size"
            :pagerCount="Number(5)"
            class="paginations"
        />
    </div>
</template>
<script>
export default {
  components: {

  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    SelectDataList: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      form: {},
      titleStatus: true,
      dataList: this.SelectDataList.value,
      matterParams: {
        // 默认显示页数
        current: 1,
        // 一页几条数据
        size: 10
      },
      // 选择的接口数据
      SelectData: []
    }
  },
  methods: {
    // 筛选已选中数据
    Filterselecteddata () {
      this.titleStatus = !this.titleStatus
      if (this.titleStatus) {
        this.dataList = this.SelectDataList.value
      } else {
        this.dataList = []
        this.SelectDataList.value.forEach((item) => {
          this.SelectDataList.Selected.forEach((items) => {
            if (item.id === items.id) {
              this.dataList.push(item)
            }
          })
        })
      }
    },
    // 搜索
    SearchSubmit (v, field) {
      return v ? this.SelectDataList.value.filter(this.createStateFilter(v, field)) : this.SelectDataList.value
    },
    // input搜索
    Serinput (e) {
      this.dataList = this.SearchSubmit(e, 'url')
    },
    createStateFilter (queryString, field) {
      return (state) => {
        // eslint-disable-next-line no-eval
        return (eval('state.' + field).toLowerCase().indexOf(queryString.toLowerCase()) > -1)
        // return (eval('state.' + field).toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
      // return this.SelectDataList.value.filter((product) => {
      //   // eslint-disable-next-line no-eval
      //   return Object.keys(product).some((key) => {
      //     console.log('this.product=========>', product[key])
      //     return String(product[key]).toUpperCase().indexOf(queryString) > -1
      //   })
      // })
      // return this.products
    },
    // 选中时触发
    handleSelectionChange (val) {
      this.SelectData = val
    },
    // 确定
    submit () {
      this.$emit('submit', { roleId: this.SelectDataList.roleId, value: this.SelectData })
      this.$refs.form.clearSelection()
      this.$emit('update:visible', false)
    },
    // 关闭
    clone () {
      this.$emit('SelectData', { roleId: this.SelectDataList.roleId, value: [] })
      this.$refs.form.clearSelection()
      this.$emit('update:visible', false)
    }
  },
  created () {
    // 回显
    if (this.SelectDataList.Selected.length > 0) {
      this.$nextTick(() => {
        this.SelectDataList.Selected.forEach((item) => {
          this.$refs.form.toggleRowSelection(item, true)
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.paginations{
    height: 30px;
    margin-top: 10px;
}
</style>
